module.exports = __webpack_public_path__ + "static/media/Shahid Jivani.8367567f.png";